import { render, staticRenderFns } from "./LinkPopinBow.vue?vue&type=template&id=03cb95d4&scoped=true&lang=pug&"
import script from "./LinkPopinBow.vue?vue&type=script&lang=js&"
export * from "./LinkPopinBow.vue?vue&type=script&lang=js&"
import style0 from "./LinkPopinBow.vue?vue&type=style&index=0&id=03cb95d4&lang=sass&scoped=true&"
import style1 from "./LinkPopinBow.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb95d4",
  null
  
)

export default component.exports